module.exports = __webpack_public_path__ + "static/img/news-20230918.0bd2930.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news-20230918.png
// module id = 2qPT
// module chunks = 0